<script lang="ts">
  let { color = 'currentColor', strokeWidth = 1.5 } = $props()
</script>

<svg
  fill="none"
  height="19"
  viewBox="0 0 19 19"
  width="19"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M17.7368 3.5L3.5 17.7368"
    stroke={color}
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width={strokeWidth}
  />
  <path
    d="M5.25307 15.7584C2.35203 12.8573 2.35203 8.15383 5.25307 5.25279C8.1541 2.35176 12.8576 2.35176 15.7587 5.25279"
    stroke={color}
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width={strokeWidth}
  />
</svg>
